<template>
  <div class="home" id="div_home" v-if="rol != null">
    <div v-if="campus != null">
      <div v-if="rol == 1">
        <GerenciaComponent @mtdBackCampus="mtdBackCampus" :rolname="rolname" :dataRoles="dataRoles" />
      </div>
      <div v-else-if="rol == 2">
        <AdmisionComponet :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 3">
        <VigilanteComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 4">
        <MaintenanceComponent @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 5">
        <LogisticaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 6 || rol == 7 || rol == 16">
        <AsistencialComponent :rolname="rolname" :dataRoles="dataRoles" @openModalRecipe="openModalRecipe" />
        <cModalRecipe :title="modalRecipe.title" :boo_modal="modalRecipe.modal_form"
          :Clinicahistory="modalRecipe.patient" :showHistory="showHistory" @closeModalRecipe="closeModalRecipe">
        </cModalRecipe>
      </div>
      <div v-else-if="rol == 8">
        <AdministracionComponent @mtdBackCampus="mtdBackCampus" :rolname="rolname" :dataRoles="dataRoles" />
      </div>
      <div v-else-if="rol == 9">
        <JefeAdmisionComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 10">
        <FarmaciaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 11">
        <RhComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 12">
        <TesoreriaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 13">
        <FacturacionComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 14">
        <DirectorComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 15">
        <LimpiezaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 17">
        <MarketingComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 18">
        <JefaEnfermeriaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 19">
        <GerenciaGeneralView :rolname="rolname" @mtdBackCampus="mtdBackCampus" :dataRoles="dataRoles" />
      </div>
      <div v-else-if="rol == 20">
        <ProveedorView :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 22">
        <LaboratorioView :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 24">
        <QuimicoFarmaceuticoView @mtdBackCampus="mtdBackCampus" />
      </div>
    </div>
    <div v-else>
      <CampusComponent :dataRoles="dataRoles" :dataCampus="dataCampus" @mtdSelectCampus="mtdSelectCampus"
        @mtdBackRol="mtdBackRol" />
    </div>
  </div>
  <div v-else>
    <RolesVue :dataRoles="dataRoles" @mtdSelectRol="mtdSelectRol" v-if="page != 'tareas_asignadas'" />
    <!-- <FooterVue  @mtdChangePage="mtdChangePage" :pageView="page" @mtdBackCampus="mtdBackCampus" /> -->
    <TareasVue v-if="page == 'tareas_asignadas'" @mtdChangePage="mtdChangePage" />
  </div>
</template>

<script>
import CampusComponent from "./Campus/index.vue";
import RolesVue from "./Rol/index.vue";
import GerenciaComponent from './Gerencia/GerenciaView.vue';
import VigilanteComponent from "./Vigilante/VigilanteView.vue";
import MaintenanceComponent from "./Maintenance/MaintenanceView.vue";
import AsistencialComponent from './Asistencial/AsistencialView.vue';
import LogisticaComponent from './Logistica/LogisticaView.vue';
import FarmaciaComponent from './Farmacia/FarmaciaView.vue';
import JefeAdmisionComponent from "./JefeAdmision/JefeAdmisionView.vue";
import AdmisionComponet from './Admision/AdmisionView.vue'
import TesoreriaComponent from "./Tesoreria/TesoreriaView.vue";
import AdministracionComponent from "./Administracion/AdministracionView.vue"
import FacturacionComponent from "./Facturacion/FacturacionView.vue";
import DirectorComponent from "./Director/DirectorView.vue";
import FooterVue from "@/views/FooterView.vue";
import TareasVue from "../components/Tareas/Tareas.vue";
import RhComponent from "./Rh/RecursosHView.vue";
import JefaEnfermeriaComponent from "./JefaEnfermeria/JefaEnfermeriaView.vue";
import LimpiezaComponent from "./Limpieza/LimpiezaView.vue";
import MarketingComponent from "./Marketing/MarketingView.vue";
import GerenciaGeneralView from "./GerenciaGeneral/GerenciaGeneralView.vue";
import ProveedorView from "./Proveedor/ProveedorView.vue";
import cModalRecipe from '@/components/Asistencial/Modals/cModalRecipeAlta.vue'
import LaboratorioView from "./Laboratorio/index.vue";
import QuimicoFarmaceuticoView from "./QuimicoFarmaceutico/QuimicoFarmaceuticoView.vue";


import { mapActions } from 'vuex'

export default {
  name: 'HomeView',
  components: {
    CampusComponent,
    RolesVue,
    GerenciaComponent,
    VigilanteComponent,
    MaintenanceComponent,
    AsistencialComponent,
    LogisticaComponent,
    FarmaciaComponent,
    JefeAdmisionComponent,
    AdmisionComponet,
    TesoreriaComponent,
    AdministracionComponent,
    FacturacionComponent,
    DirectorComponent,
    FooterVue,
    TareasVue,
    RhComponent,
    JefaEnfermeriaComponent,
    LimpiezaComponent,
    MarketingComponent,
    GerenciaGeneralView,
    ProveedorView,
    cModalRecipe,
    LaboratorioView,
    QuimicoFarmaceuticoView
  },
  data() {
    return {
      page: "home",
      rol: null,
      rolname: null,
      dataCampus: [],
      campus: 1,
      dataRoles: [],
      modalRecipe: {
        title: "",
        modal_form: false,
        patient: {}
      },
      showHistory: false,
    }
  },
  created() {
    const user = this.$store.getters.get__user
    
    if (user.roles.length == 1) {
      this.rol = user.roles[0].role_id;
      this.rolname = user.roles[0].role.name;
    } else {
      this.dataRoles = user.roles;
      this.rolname = '';
    }
    this.dataCampus = this.$store.getters.get__datacampus;
    this.mtdgetcheck();
  },
  methods: {
    ...mapActions(['get', 'post']),

    mtdSelectCampus: function (id) {
      this.campus = id;
      this.$store.commit("mt_set_campus", id);
    },
    mtdSelectRol: function (id, name_rol) {
      this.rol = id;
      this.rolname = name_rol;
      this.mtdgetcheck();
    },
    mtdBackRol: function () {
      this.rol = null;
    },
    mtdBackCampus: function () {
      this.campus = null;
      this.$store.commit("mt_set_campus", null);
    },
    mtdgetcheck: function () {
      const user = this.$store.getters.get__user
      this.get({
        url: this.$store.getters.get__url + "/Authentication/check",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.check = response.data.check;
          if (this.check) {
            if (this.rol == 1) {
              this.$router.push('/jefeOperaciones')
            } else
              if (this.rol == 2) {
                this.$router.push('/admision')
              } else
                if (this.rol == 3) {
                  this.$router.push('/vigilante')
                } else
                  if (this.rol == 4) {
                    this.$router.push('/maintenance')
                  } else
                    if (this.rol == 5) {
                      this.$router.push('/logistica')
                    } else
                      if (this.rol == 6) {
                        this.$router.push('/medico')
                      } else
                        if (this.rol == 7) {
                          this.$router.push('/enfermera')
                        } else
                          if (this.rol == 8) {
                            this.$router.push('/administracion')
                          } else
                            if (this.rol == 9) {
                              this.$router.push('/jefatura')
                            } else
                              if (this.rol == 10) {
                                this.$router.push('/farmacia')
                              } else
                                if (this.rol == 11) {
                                  this.$router.push('/rh')
                                } else
                                  if (this.rol == 12) {
                                    this.$router.push('/tesoreria')
                                  } else
                                    if (this.rol == 13) {
                                      this.$router.push('/facturacion')
                                    } else
                                      if (this.rol == 14) {
                                        this.$router.push('/director')
                                      } else
                                        if (this.rol == 15) {
                                          this.$router.push('/limpieza')
                                        } else
                                          if (this.rol == 16) {
                                            this.$router.push('/tecnico')
                                          } else
                                            if (this.rol == 17) {
                                              this.$router.push('/marketing')
                                            } else
                                              if (this.rol == 18) {
                                                this.$router.push('/jefaEnfermeria')
                                              } else
                                                if (this.rol == 19) {
                                                  this.$router.push('/gerencia')
                                                } else
                                                  if (this.rol == 20) {
                                                    this.$router.push('/proveedor')
                                                  } else
                                                   if (this.rol == 24) {
                                                    this.$router.push('/quimicoFarmaceutico')
                                                  } else {
                                                    this.$router.push('/home')
                                                  }
          } else {
            if (user.document_type == 'DNI') {
              this.$router.push('/login')
            } else if (user.document_type == 'RUC') {
              this.$router.push('/loginProvider')
            } else {
              this.$router.push('/login')
            }
          }
        })
    },
    mtdChangePage: function (page) {
      this.page = page;
    },

    //Modal Recipes Alta
    openModalRecipe: function (patient, rolname) {
      this.post({
        url: this.$store.getters.get__url + "/Hospitalization/mtdRecipeDischarge",
        token: this.$store.getters.get__token,
        params: patient
      }).then((response) => {
        if (response.statusCode === 200) {

          if (response.data) {
            patient.recipe = response.data.recipe;
            patient.dieta = response.data.dieta;
            patient.recomendations = response.data.recomendation;
            this.showHistory = true;
          } else {
            this.showHistory = rolname !== 'DOCTOR(A)';
          }

          this.modalRecipe = {
            title: "RECETAS DE ALTA",
            modal_form: true,
            patient: patient
          }

        } else {
          this.$refs.SweetAlert.showError("Error");
        }
      })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    closeModalRecipe: function () {
      this.modalRecipe = {
        title: "",
        modal_form: false,
        patient: {}
      }
    },
  }
}
</script>